






import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class StaticLabel extends Vue {
    @Prop({
        required: true
    })
    label!: string;

    @Prop({
        required: true
    })
    content!: string | null;

    @Prop({
        default: 'N/A'
    })
    defaultIfMissing!: string;
}
